import React from 'react'
import {
  getGpsIntegrityLabel,
  hasGpsIntegritySignal,
  isSevereGpsIntegrity,
} from 'App/helpers/gpsIntegrity'
import styles from './styles.css'
import moment from 'moment'

export default function ImportantInfo(props) {
  const {vehicle} = props
  const gpsIntegrity = vehicle.gpsIntegrity
  // Una sospecha la levantó un detector y nadie la revisó: no puede leerse
  // como un hecho probado, por eso se distingue de la confirmada.
  const isSevere = isSevereGpsIntegrity(gpsIntegrity)
  const signals = ((gpsIntegrity && gpsIntegrity.signals) || []).filter(Boolean)

  return (
    <div className={styles.container}>
      {vehicle.bannedAt ? (
        <div className={styles.containerInfo}>
          <span className={styles.badgeDanger}>
            Baneado,{' '}
            {vehicle.liftBanAt
              ? moment(vehicle.liftBanAt).format('DD/MM/YYYY HH:mm')
              : 'de forma indefinida'}
          </span>
        </div>
      ) : null}

      {hasGpsIntegritySignal(gpsIntegrity) ? (
        <div className={styles.containerInfo}>
          <span
            className={isSevere ? styles.badgeDanger : styles.badgeWarning}
            title={signals.join(' · ')}
          >
            {getGpsIntegrityLabel(gpsIntegrity)}
          </span>
          {signals.length ? <div className={styles.signals}>{signals.join(' · ')}</div> : null}
        </div>
      ) : null}

      <div>{vehicle.phone}</div>
    </div>
  )
}
